export const routes = {
  accepted: '/accepted',
  aboutApp: '/about-app',
  accountMain: '/account/main',
  accountRequestInfo: '/account/request-information',
  accountDelete: '/account/delete',
  addCard: `/payment/add-card`,
  addGiftCard: `/payment/add-gift-card`,
  deliveryAddress: `/delivery-address`,
  deliveryTerms: `/delivery-terms`,
  badgeDetail: id => `/badges/${id}`,
  base: '/',
  bkRewards: '/bkrewards',
  cart: '/cart',
  cartMain: '/cart/main',
  cartAddExtras: `/cart/extras`,
  cartPayment: `/cart/payment`,
  cartCheckout: `/checkout`,
  cartStoreConfirmation: `/cart/payment/store-confirmation`,
  campaigns: '/campaigns',
  claimPointsAccepted: `/claim-points/accepted`,
  claimPointsBase: `/claim-points`,
  claimPointsRoot: `/claim`,
  claimPointsProcessing: `/claim-points/claim`,
  claimPointsSurveyRoot: '/survey',
  claimPointsSurvey: `/claim-points/survey`,
  communication: `/communication-preferences`,
  confirmOtp: '/confirm-otp',
  delivery: '/delivery',
  deliveryStoresClosed: `/store-locator/delivery-stores-closed`,
  diagnostics: '/diagnostics',
  drawer: 'Drawer',
  favoritesMain: `/menu/favorites/main`,
  favorites: `/menu/favorites`,
  favoriteEditor: `/menu/favorites/:favoriteId/edit`,
  // TODO: Remove this route and use the rewardsHistory route instead,
  // once the History tab is replaced with the Loyalty Profile tab
  history: '/history',
  accountInfo: '/account/info',
  languageSelector: '/language-selector',
  loading: '/loading',
  loyaltyDashboard: '/rewards/details',
  loyaltyHome: '/rewards',
  loyaltyRewardsDashboard: '/rewards/dashboard',
  loyaltyRewardsList: '/rewards',
  loyaltyOfferList: '/offers',
  loyaltyOfferDetails: '/offers/:loyaltyEngineId',
  loyaltyOfferGroup: '/offers/group',
  loyaltyChallengeCompleted: '/challenge-completed',
  loyaltyChallengeDetails: '/challenge-details',
  loyaltyActivateQuest: '/activate-challenge',
  menu: '/menu',
  menuEmpty: '/menu-empty',
  menuFavorites: '/menu/favorites',
  menuMain: '/menu/main',
  menuContent: '/menu-content',
  menuRecent: '/menu/recent-items',
  noDeliveryStores: `/store-locator/no-delivery-stores`,
  notFound: '/not-found',
  notFound404: '/not-found/404',
  notificationInbox: '/notification-inbox',
  nutritionExplorer: '/nutrition-explorer',
  offers: '/offers',
  orderConfirmation: '/order-confirmation',
  orders: '/account/orders',
  orderDetails: (rbiOrderId: string | null | undefined) => `/orders/${rbiOrderId}`,
  partnerships: '/partnerships',
  payment: '/account/payment',
  productDetail: '/product-detail',
  myCode: '/my-code',
  whopperGuarantee: '/whopper-guarantee',
  rewards: '/rewards',
  rewardsEarn: '/rewards/earn',
  rewardsHistory: '/rewards/history',
  rewardsHowItWorks: '/rewards/profile/how-it-works',
  rewardsList: '/rewards',
  rewardsProfile: '/rewards/profile',
  // TODO: this route is not being used remove
  rewardsOnboarding: '/rewards-onboarding',
  royalPerks: '/royalperks',
  scanMain: '/scan-main',
  scaryPlaces: '/scaryplaces',
  signOut: '/signout',
  staticPage: '/static-page',
  store: `/store-locator/store`,
  support: '/support',
  supportCategories: '/support/categories',
  supportCategory: '/support/categories/:categoryId',
  supportOrders: '/support/orders',
  supportForm: '/support/form',
  supportPage: 'SupportPage',
  tabs: 'Tabs',
  transferGiftCard: `/payment/transfer-gift-card`,
  trending: '/trending',
  contactUs: 'contact-us',
  modalStaticPage: '/modal-static-page',
  walmart: '/walmartplus',
  walmartLocation: '/walmartLocation',
  walmartRedirect: '/walmart-redirect',

  //TODO: this route is a static page in sanity. Ensure it exists in data set

  // Default localizable routes
  acceptGift: '/accept-gift',
  account: '/account',
  sendGift: '/gift',
  exploreMenu: '/explore-menu',
  storeLocator: '/store-locator',
  hockeyChallenge: '/hockey-challenge',
  scan: '/scan',
  foundation: '/foundation', //TODO: this route is not being used remove
  textTerms: '/text-terms',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
  termsConditionsRewards: '/terms-conditions-rewards',
  mobileOrderTerms: '/mobile-order-terms',
};

export const redirectRoutes = {
  numeriser: routes.scan,
  compte: routes.account,
  'claim-crowns': routes.claimPointsBase,
  'claim-crowns/survey': `${routes.claimPointsBase}/survey`,
  'recompenses-lintegration': routes.rewardsOnboarding, // TODO: this route is not being used remove
  'localisateur-de-magasin': routes.storeLocator,

  // Static routes
  'conditions-livraison-mobile': `${routes.mobileOrderTerms}/?lang=fr`,
  'conditions-livraison': `${routes.deliveryTerms}/?lang=fr`,
  'conditions-dutilisation': `${routes.termsOfService}/?lang=fr`,
  'politique-de-confidentialite': `${routes.privacyPolicy}/?lang=fr`,
  'conditions-recompenses': `${routes.termsConditionsRewards}/?lang=fr`,
};
